import React from 'react'

export const HouseSizeMIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='89'
      height='65'
      viewBox='0 0 89 65'
      className='f-c-st-pri f-c-fi-whi'
      fill='none'
      {...props}>
      <path
        d='M80.0313 23.4686H8.11719V60.6811H80.0313V23.4686Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M87.0742 23.4685H1.07422L14.3063 3.01129H73.8422L87.0742 23.4685Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M87.0742 59.7429H1.07422V63.266H87.0742V59.7429Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M59.3009 63.2693H28.8479V25.2773L44.0744 6.37921L59.3009 25.2773V63.2693Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M28.8479 21.221V7.4895H35.2631V15.4098L28.8479 21.221Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M44.074 1L24.5111 25.2774H28.8476L44.074 6.37922L59.3005 25.2774H63.637L44.074 1Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M50.9923 38.5634H37.1528V63.2693H50.9923V38.5634Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M44.0743 20.5461C45.1707 20.5461 46.2222 20.9816 46.9974 21.7569C47.7727 22.5322 48.2082 23.5837 48.2082 24.68V30.8219H39.9403V24.6767C39.9412 23.5809 40.3771 22.5302 41.1523 21.7557C41.9275 20.9812 42.9785 20.5461 44.0743 20.5461V20.5461Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M39.9403 50.098V52.575'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21.6935 33.4238H15.2749V47.3545H21.6935V33.4238Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M72.877 33.4238H66.4584V47.3545H72.877V33.4238Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
